<template>
  <div class="container mt-5 mb-5 pb-5" style="background: #fff">
    <div class="row">
      <div class="col-md-12">
        <h1 class="text-center" style="color: #000;">{{ title }}</h1>
        <br />
        <div style="color: black" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "page",
  data() {
    return {
      title: null,
      content: null
    };
  },
  async mounted() {
    // console.log(this.$route.params.slug);
    await axios
      .get(
        `${process.env.VUE_APP_API_URL}/api/footer-menu/page/${this.$route.params.slug}`
      )
      .then(res => {
        // console.log(res);
        this.content = res.data.content;
        this.title = res.data.name;
      })
      .catch(error => {
        // console.log(error);
        this.$router.push({ name: "404" });
      });
  },

  watch: {
    "$route.params.slug": function(slug) {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/footer-menu/page/${this.$route.params.slug}`
        )
        .then(res => {
          // console.log(res);
          this.content = res.data.content;
          this.title = res.data.name;
        })
        .catch(error => {
          console.log(error);
          this.$router.push({ name: "404" });
        });
    }
  }
};
</script>
